import { render, staticRenderFns } from "./CAxASXxClarificationsPage.vue?vue&type=template&id=657c6760"
import script from "./CAxASXxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxASXxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxASXxClarificationsPage.vue?vue&type=style&index=0&id=657c6760&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports